module.exports = __webpack_public_path__ + "static/media/walkplot.63b0f9f8.png";